import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	noInteractionContainer: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		width: "100%",
	},
	component: {
		backgroundColor: tokens.colorNeutralBackground1Selected,
		width: "100%",
		height: "100%",
		position: "absolute",
		top: "0",
		left: "0",
		borderRadius: "50%"
	},
	iconContainer: {
		width: "400px",
		height: "400px",
		position: "relative",
	},
	iconElement: {
		position: "absolute",
		bottom: "10px"
	},
	boldText: {
		paddingTop: "65px",
	},
	regularText: {
		textAlign: "center",
		width: "500px",
		paddingTop: "40px",
		lineHeight: "1.5",
		whiteSpace: 'pre-line'
	},
	noInteractionIcon: {
		// width: "600px",
	},
});
